<template>
  <div id="calcView">
    <ul id="calcViewHead">
      <li>Продукт</li>
      <li>Срок займа<br/>{{getSelectedPskInfo.calcWeekTitle}}</li>
      <li>ПСК %</li>
      <li>ПСК руб, переплата по займу</li>
      <li>{{getSelectedPskInfo.periodPayTitle}} платеж</li>
      <li>Итоговая сумма выплат</li>
    </ul>
    <ul id="calcViewBody">
      <li>{{getSelectedPskInfo.DlProductTypeName}}</li>
      <li>{{getSelectedPskInfo.Period}}</li>
      <li>{{getSelectedPskInfo.PercentageRate}}</li>
      <li>{{getSelectedPskInfo.OutDeltaPayments | currency(' р.', 2, { decimalSeparator: ',',thousandsSeparator: ' ',symbolOnLeft: false  })}}</li>
      <li>{{getSelectedPskInfo.FixedPay | currency(' р.', 2, { decimalSeparator: ',',thousandsSeparator: ' ',symbolOnLeft: false  })}}</li>
      <li>{{getSelectedPskInfo.OutPayments | currency(' р.', 2, { decimalSeparator: ',',thousandsSeparator: ' ',symbolOnLeft: false  })}}</li>
    </ul>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import Vue2Filters from 'vue2-filters'

  export default {
    name: "productInfo",
    computed:{
      ...mapGetters(['getSelectedPskInfo']),
    },
    mixins: [Vue2Filters.mixin]
  }
</script>

<style scoped>
  #calcView{font-size: 14px;}
  #calcView ul{display: flex;list-style: none;margin:0;padding:0;border-width: 0 0 1px 1px;border-style: solid;border-color: gray}
  #calcView ul li{width: calc(100% / 6 - 1px - 10px);border-right:1px solid gray;padding: 10px 5px;word-break: break-word;}
  #calcView #calcViewHead{border-top:1px solid gray;}
</style>